var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 265,
    viewBox: "0 0 264 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1469_6508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 0.755859H208.283V56.3924H264V0.755859Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8332 151.572C50.265 150.855 48.6835 150.168 47.0821 149.515L0 196.529V203.33L51.8332 151.572Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6675 155.497C58.1923 154.691 56.7005 153.914 55.1888 153.168L0 208.277V215.078L59.6675 155.497Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0237 164.657C72.7279 163.702 71.4156 162.769 70.0833 161.86L0 231.842V238.574L74.0237 164.657Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5888 169.852C79.3595 168.811 78.1102 167.792 76.8378 166.797L0 243.524V250.325L80.5888 169.852Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5171 148.128C41.8493 147.508 40.1681 146.921 38.4671 146.37L0 184.782V191.583L43.5171 148.128Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1237 141.237C13.0671 140.989 10.9939 140.79 8.90743 140.644L0 149.538V156.339L15.1237 141.237Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 144.588L4.19622 140.398C2.80413 140.352 1.40539 140.325 0 140.325V144.588Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7552 175.439C85.6023 174.321 84.4262 173.229 83.2334 172.154L0 255.271V262.072L86.7552 175.442V175.439Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2405 142.884C23.3334 142.492 21.4097 142.144 19.4727 141.842L0 161.286V168.088L25.2405 142.884Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6728 145.212C32.8953 144.698 31.0979 144.224 29.2905 143.789L0 173.034V179.835L34.6728 145.212Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0997 159.893C65.6977 158.997 64.2723 158.128 62.8304 157.285L0 220.025V226.896L67.0997 159.893Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.036 244.953C122.727 243.022 122.375 241.108 121.976 239.21L96.3936 264.756H103.205L123.036 244.953Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.066 235.173C120.624 233.368 120.142 231.583 119.624 229.812L84.6289 264.756H91.4399L121.066 235.173Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.454 226.032C117.9 224.337 117.308 222.658 116.684 220.996L72.8608 264.756H79.6751L118.454 226.032Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.265 255.474C124.113 253.397 123.907 251.333 123.654 249.286L108.162 264.756H114.973L124.269 255.474H124.265Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.525 260.164L119.926 264.756H124.611C124.611 263.22 124.581 261.687 124.528 260.164H124.525Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.454 201.715C106.63 200.318 105.779 198.938 104.902 197.574L37.6232 264.756H44.3179L107.454 201.711V201.715Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9417 187.824C96.9384 186.553 95.9117 185.302 94.8585 184.071L14.0571 264.756H20.8947L97.9384 187.824H97.9417Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.925 194.601C102.005 193.257 101.062 191.934 100.088 190.63L25.8518 264.759H32.6661L102.925 194.601Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6 209.348C110.846 207.835 110.062 206.342 109.248 204.869L49.2716 264.759H56.1092L111.6 209.348Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.285 217.447C114.624 215.844 113.933 214.258 113.208 212.692L61.0696 264.756H67.9071L115.285 217.447Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5462 181.437C91.4664 180.239 90.3633 179.065 89.237 177.91L2.26587 264.756H9.10342L92.5462 181.433V181.437Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4673 139.015V35.6242C22.4673 30.4288 26.6834 26.2188 31.8864 26.2188H229.627C234.83 26.2188 239.046 30.4288 239.046 35.6242V49.2928",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.327 194.734L169.84 51.4824H71.1309L118.14 199.528C120.788 207.872 114.552 216.382 105.787 216.382H199.456C210.716 216.382 218.73 205.45 215.324 194.734H215.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.14 199.528L71.1309 51.4824H63.9013L71.5761 75.6513L79.8257 101.628L111.053 199.973C112.176 203.513 109.532 207.122 105.81 207.122H96.6139C94.2184 207.122 92.0954 205.573 91.3711 203.29L59.0904 101.628H51.8309L84.5867 204.783C86.7795 211.691 93.1985 216.382 100.455 216.382H105.787C114.552 216.382 120.791 207.872 118.14 199.528Z",
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6106 207.122H105.807C109.528 207.122 112.173 203.512 111.05 199.972L79.8224 101.628H59.0872L91.3679 203.29C92.0921 205.572 94.2118 207.122 96.6106 207.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9014 51.4824L71.5762 75.6513L63.9014 51.4824Z",
    fill: "#7F9398"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.624 57.1025L169.84 51.4824H63.9014L111.05 199.969C112.173 203.509 109.528 207.119 105.807 207.119H96.6106C94.2152 207.119 92.0921 205.57 91.3679 203.287L59.0872 101.625",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7659 189.605L84.5867 204.783C86.7795 211.691 93.1984 216.382 100.455 216.382H199.456C210.716 216.382 218.73 205.45 215.324 194.734L185.243 100.003",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8224 101.625H51.8309L67.7819 151.864",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1309 51.4824L118.14 199.528C120.788 207.872 114.552 216.382 105.787 216.382",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6034 68.4756H159.693",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.421 111.996H173.511",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.76 119.354H178.671",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8827 75.6514H166.887",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2219 105.065H176.226",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.119 126.786H154.099",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.442 175.047H193.532",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.781 182.406H198.692",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14 189.837H174.119",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0857 98.3311H161.561",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0289 82.4131H147.6",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.468 143.636H176.226",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.748 150.809H190.751",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.894 157.573H187.253",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3469 114.275H83.8392",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7092 121.707H86.1982",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0322 169.969H101.525",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3679 177.327H103.86",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7301 184.759H106.219",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0582 138.557H91.5505",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3374 145.729H93.8264",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4838 152.491H95.9761",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7819 151.863C69.7388 158.028 65.1306 164.311 58.6585 164.311H32.0392C26.7532 164.311 22.4673 168.591 22.4673 173.869V233.079C22.4673 238.274 26.6834 242.484 31.8864 242.484H229.627C234.83 242.484 239.046 238.274 239.046 233.079V84.1474C239.046 78.8691 234.76 74.5893 229.474 74.5893L184.186 74.5993C180.013 74.5993 176.322 71.9021 175.06 67.9309L171.621 57.1055",
    stroke: "#7F9398",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1469_6508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white",
    transform: "translate(0 0.755859)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperIcon);
export default __webpack_public_path__ + "static/media/paper-icon.f20146ef.svg";
export { ForwardRef as ReactComponent };